import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { FaMosque, FaSignInAlt, FaGlobe, FaChevronDown, FaSearch, FaLanguage, FaLandmark, FaUtensils, FaBook, FaFire, FaClock, FaCheckCircle, FaQuestionCircle, FaPlus, FaThumbsUp, FaComment, FaBookOpen, FaVideo, FaArrowRight, FaPaperPlane, FaTimes, FaTelegram, FaTwitter, FaInstagram, FaYoutube, FaBars, FaLaugh, FaHandshake, FaExclamationTriangle, FaLightbulb, FaHeart, FaStar, FaGift, FaCoffee, FaUsers, FaSmile, FaRegSmile, FaRegHeart, FaRegStar, FaMoon, FaSun, FaSignOutAlt } from 'react-icons/fa';
import { USER_PROFILES } from '../data/userProfiles';
import { useTheme } from '../contexts/ThemeContext';
import { useAuth } from '../contexts/AuthContext';

const categories = [
  { icon: <FaLanguage className="text-amber-600 text-xl" />, title: 'Farsi Language', desc: 'Grammar, vocabulary, pronunciation', color: 'amber' },
  { icon: <FaLandmark className="text-blue-600 text-xl" />, title: 'Persian Culture', desc: 'Traditions, history, arts', color: 'blue' },
  { icon: <FaUtensils className="text-green-600 text-xl" />, title: 'Persian Cuisine', desc: 'Recipes, cooking techniques', color: 'green' },
  { icon: <FaBook className="text-purple-600 text-xl" />, title: 'Literature', desc: 'Poetry, books, authors', color: 'purple' },
];

const tabs = [
  { icon: <FaFire className="mr-2" />, label: 'Trending' },
  { icon: <FaClock className="mr-2" />, label: 'Recent' },
  { icon: <FaCheckCircle className="mr-2" />, label: 'Answered' },
  { icon: <FaQuestionCircle className="mr-2" />, label: 'Unanswered' },
];

const questions = [
  {
    user: USER_PROFILES.sarahJohnson,
    category: 'Farsi Language',
    categoryColor: 'amber',
    icon: <FaLanguage className="mr-1" />,
    title: `What's the difference between "khodahafez" and "bedrood"?`,
    content: `I've heard both used as goodbye phrases but I'm not sure when to use each one. Can someone explain the difference and proper usage?`,
    likes: 24,
    answers: 8,
    time: '2 hours ago',
  },
  {
    user: USER_PROFILES.michaelClark,
    category: 'Persian Culture',
    categoryColor: 'blue',
    icon: <FaLandmark className="mr-1" />,
    title: 'Can someone explain the significance of Nowruz celebrations?',
    content: `I'm fascinated by Persian New Year traditions but don't fully understand the meaning behind the Haft-Seen table items. What does each item represent?`,
    likes: 42,
    answers: 15,
    time: '1 day ago',
  },
  {
    user: USER_PROFILES.neginNickparsa,
    category: 'Persian Cuisine',
    categoryColor: 'green',
    icon: <FaUtensils className="mr-1" />,
    title: `What's the secret to perfect tahdig in Persian rice?`,
    content: `I've tried making tahdig several times but can't get that perfect golden crust. Any tips from experienced Persian cooks? What's the best oil to use?`,
    likes: 37,
    answers: 12,
    time: '3 days ago',
  },
  {
    user: USER_PROFILES.aliReza,
    category: 'Literature',
    categoryColor: 'purple',
    icon: <FaBook className="mr-1" />,
    title: 'How to understand Hafez poetry for beginners?',
    content: `I'm trying to read Hafez's poetry but find it very complex. Are there any good resources or approaches for beginners to understand the metaphors and symbolism?`,
    likes: 56,
    answers: 23,
    time: '5 days ago',
  },
  {
    user: USER_PROFILES.davidChen,
    category: 'Farsi Language',
    categoryColor: 'amber',
    icon: <FaLanguage className="mr-1" />,
    title: 'Best way to learn Persian script?',
    content: `I'm struggling with reading and writing Persian script. What's the most effective method to learn the alphabet and improve my reading speed?`,
    likes: 31,
    answers: 11,
    time: '1 week ago',
  },
  {
    user: USER_PROFILES.davidChen,
    category: 'Persian Culture',
    categoryColor: 'blue',
    icon: <FaLandmark className="mr-1" />,
    title: 'What are traditional Persian wedding customs?',
    content: `I'm attending a Persian wedding soon and want to understand the customs and traditions. What should I expect and how should I participate respectfully?`,
    likes: 28,
    answers: 9,
    time: '1 week ago',
  },
  {
    user: USER_PROFILES.ninaPatel,
    category: 'Persian Cuisine',
    categoryColor: 'green',
    icon: <FaUtensils className="mr-1" />,
    title: 'Authentic Persian kebab recipe?',
    content: `I want to make authentic Persian kebabs at home. What's the best cut of meat to use and what spices are essential for the marinade?`,
    likes: 44,
    answers: 16,
    time: '1 week ago',
  },
  {
    user: USER_PROFILES.amirHosseini,
    category: 'Literature',
    categoryColor: 'purple',
    icon: <FaBook className="mr-1" />,
    title: 'Rumi vs Hafez - which poet to start with?',
    content: `I'm new to Persian poetry and want to start reading either Rumi or Hafez. Which one would be more accessible for a beginner and why?`,
    likes: 39,
    answers: 14,
    time: '2 weeks ago',
  },
  {
    user: USER_PROFILES.sofiaRodriguez,
    category: 'Farsi Language',
    categoryColor: 'amber',
    icon: <FaLanguage className="mr-1" />,
    title: 'How to pronounce Persian vowels correctly?',
    content: `I'm having trouble with Persian vowel sounds, especially the difference between short and long vowels. Any tips for improving pronunciation?`,
    likes: 33,
    answers: 12,
    time: '2 weeks ago',
  },
  {
    user: USER_PROFILES.karimZadeh,
    category: 'Persian Culture',
    categoryColor: 'blue',
    icon: <FaLandmark className="mr-1" />,
    title: 'Meaning of Persian carpet patterns?',
    content: `I inherited a beautiful Persian carpet and want to understand the meaning behind its patterns and symbols. How can I identify the region and meaning?`,
    likes: 25,
    answers: 8,
    time: '2 weeks ago',
  },
  {
    user: USER_PROFILES.mariaSantos,
    category: 'Persian Cuisine',
    categoryColor: 'green',
    icon: <FaUtensils className="mr-1" />,
    title: 'How to make Persian tea properly?',
    content: `I love Persian tea but can't seem to make it taste the same as in restaurants. What's the proper way to brew Persian tea and what tea leaves should I use?`,
    likes: 41,
    answers: 13,
    time: '3 weeks ago',
  },
  {
    user: USER_PROFILES.hassanMirza,
    category: 'Literature',
    categoryColor: 'purple',
    icon: <FaBook className="mr-1" />,
    title: 'Modern Persian literature recommendations?',
    content: `I'm interested in contemporary Persian literature and authors. Can anyone recommend some modern Persian novels or short stories that have been translated?`,
    likes: 22,
    answers: 7,
    time: '3 weeks ago',
  },
  {
    user: USER_PROFILES.emmaThompson,
    category: 'Farsi Language',
    categoryColor: 'amber',
    icon: <FaLanguage className="mr-1" />,
    title: 'Common Persian idioms and expressions?',
    content: `I want to learn some common Persian idioms and expressions to sound more natural. What are some popular ones and their meanings?`,
    likes: 38,
    answers: 15,
    time: '3 weeks ago',
  },
  {
    user: USER_PROFILES.mohammadKarimi,
    category: 'Persian Culture',
    categoryColor: 'blue',
    icon: <FaLandmark className="mr-1" />,
    title: 'Persian music instruments and their history?',
    content: `I'm fascinated by Persian traditional music. What are the main instruments used and what's their historical significance in Persian culture?`,
    likes: 29,
    answers: 10,
    time: '4 weeks ago',
  },
  {
    user: USER_PROFILES.drFatimaAlZahra,
    category: 'Persian Cuisine',
    categoryColor: 'green',
    icon: <FaUtensils className="mr-1" />,
    title: 'Vegetarian Persian dishes for beginners?',
    content: `I'm vegetarian and want to explore Persian cuisine. What are some traditional vegetarian Persian dishes that are easy to make at home?`,
    likes: 35,
    answers: 11,
    time: '4 weeks ago',
  },
  {
    user: USER_PROFILES.javadNouri,
    category: 'Literature',
    categoryColor: 'purple',
    icon: <FaBook className="mr-1" />,
    title: 'Understanding Persian calligraphy styles?',
    content: `I'm learning Persian calligraphy and want to understand the different styles like Nastaliq and Shekasteh. Which style should I start with as a beginner?`,
    likes: 27,
    answers: 9,
    time: '4 weeks ago',
  }
];

const resources = [
  {
    icon: <FaBookOpen className="text-amber-600 text-xl" />,
    title: <span><span style={{ fontFamily: 'Noto Nastaliq Urdu, serif' }}>Farsi</span> Vocabulary Builder</span>,
    desc: 'Essential words and phrases categorized by topics with pronunciation guides.',
    color: 'amber',
    link: '/vocabulary',
    linkText: 'Explore',
  },
  {
    icon: <FaVideo className="text-blue-600 text-xl" />,
    title: 'Cultural Videos',
    desc: 'Documentaries and explanations of Persian traditions, holidays, and customs.',
    color: 'blue',
    link: '#',
    linkText: 'Watch Now',
  },
  {
    icon: <FaUtensils className="text-green-600 text-xl" />,
    title: 'Recipe Collection',
    desc: 'Step-by-step guides to making authentic Persian dishes with ingredient lists.',
    color: 'green',
    link: '/cultural/recipes',
    linkText: 'Browse Recipes',
  },
];

const Forum: React.FC = () => {
  const { category } = useParams<{ category?: string }>();
  const { theme, toggleTheme } = useTheme();
  const { user, logout } = useAuth();
  const [activeTab, setActiveTab] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [showLangDropdown, setShowLangDropdown] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [filteredQuestions, setFilteredQuestions] = useState(questions);
  const [displayedQuestions, setDisplayedQuestions] = useState(questions.slice(0, 3));
  const [showLoadMore, setShowLoadMore] = useState(true);
  const [activeTaarofTab, setActiveTaarofTab] = useState('culture');

  useEffect(() => {
    if (category) {
      const categoryTitle = category.split('-').map(word => 
        word.charAt(0).toUpperCase() + word.slice(1)
      ).join(' ');
      
      const filtered = questions.filter(q => 
        q.category.toLowerCase() === categoryTitle.toLowerCase()
      );
      setFilteredQuestions(filtered);
      setDisplayedQuestions(filtered.slice(0, 3));
      setShowLoadMore(filtered.length > 3);
    } else {
      setFilteredQuestions(questions);
      setDisplayedQuestions(questions.slice(0, 3));
      setShowLoadMore(questions.length > 3);
    }
  }, [category]);

  const handleLoadMore = () => {
    const currentLength = displayedQuestions.length;
    const newQuestions = filteredQuestions.slice(currentLength, currentLength + 3);
    setDisplayedQuestions([...displayedQuestions, ...newQuestions]);
    
    if (currentLength + 3 >= filteredQuestions.length) {
      setShowLoadMore(false);
    }
  };

  return (
    <div className="gradient-bg min-h-screen font-sans" dir="ltr">
      {/* Persian Miniature Art Ornaments for Moonlight Mode */}
      {theme === 'moonlight' && (
        <>
          <div className="persian-ornament"></div>
          <div className="persian-ornament"></div>
          <div className="persian-ornament"></div>
        </>
      )}
      
      {/* Header */}
      <header className="bg-white shadow-md">
        <div className="container mx-auto px-4 py-3 flex justify-between items-center">
          <div className="flex items-center space-x-2">
            <FaMosque className="text-2xl sm:text-3xl text-amber-600" />
            <h1 className="text-lg sm:text-2xl font-bold text-gray-800">
              <span className="persian-font">دانشجویان فارسی</span>
              <span className="block text-xs sm:text-sm text-gray-500">Persian Learning Forum</span>
            </h1>
          </div>
          
          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-4">
            {/* Moonlight Mode Toggle */}
            <button
              onClick={toggleTheme}
              className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
              title={
                theme === 'light' ? 'Study with Moonlight Mode' : 
                theme === 'dark' ? 'Study with Moonlight Mode' : 
                'Switch to Light Mode'
              }
            >
              {theme === 'moonlight' ? (
                <div className="flex items-center space-x-1">
                  <FaSun className="text-amber-500" />
                  <span className="text-xs text-amber-600 font-medium">Light</span>
                </div>
              ) : (
                <div className="flex items-center space-x-1">
                  <FaMoon className="text-blue-600" />
                  <span className="text-xs text-blue-600 font-medium">Moonlight</span>
                </div>
              )}
            </button>
            
            {user ? (
              <>
                <Link to="/profile" className="bg-amber-600 hover:bg-amber-700 text-white px-4 py-2 rounded-full flex items-center transition-colors">
                  <FaSignInAlt className="mr-2" />
                  <span>Profile</span>
                </Link>
                <button 
                  onClick={logout}
                  className="bg-white border border-red-600 text-red-600 hover:bg-red-50 px-4 py-2 rounded-full transition-colors"
                >
                  <span>Logout</span>
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="bg-amber-600 hover:bg-amber-700 text-white px-4 py-2 rounded-full flex items-center transition-colors">
                  <FaSignInAlt className="mr-2" />
                  <span>Login</span>
                </Link>
                <Link to="/register" className="bg-white border border-amber-600 text-amber-600 hover:bg-amber-50 px-4 py-2 rounded-full transition-colors">
                  <span>Register</span>
                </Link>
              </>
            )}
            <div className="relative">
              <button 
                onClick={() => setShowLangDropdown(!showLangDropdown)} 
                className="flex items-center space-x-1 text-gray-600 hover:text-amber-600 transition-colors min-h-[44px] min-w-[44px] justify-center"
              >
                <FaGlobe />
                <span className="hidden sm:inline">EN</span>
                <FaChevronDown className="text-xs" />
              </button>
              {showLangDropdown && (
                <div className="absolute right-0 mt-2 w-32 bg-white rounded-md shadow-lg z-10">
                  <a href="#" className="block px-4 py-3 text-gray-800 hover:bg-amber-50 transition-colors">English</a>
                  <a href="#" className="block px-4 py-3 text-gray-800 hover:bg-amber-50 rtl-text persian-font transition-colors">فارسی</a>
                </div>
              )}
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center space-x-2">
            {/* Moonlight Mode Toggle - Mobile */}
            <button
              onClick={toggleTheme}
              className="p-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
              title={
                theme === 'light' ? 'Study with Moonlight Mode' : 
                theme === 'dark' ? 'Study with Moonlight Mode' : 
                'Switch to Light Mode'
              }
            >
              {theme === 'moonlight' ? (
                <FaSun className="text-amber-500" />
              ) : (
                <FaMoon className="text-blue-600" />
              )}
            </button>
            
            <button 
              onClick={() => setShowMobileMenu(!showMobileMenu)}
              className="p-2 text-gray-600 hover:text-amber-600 transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
            >
              <FaBars className="text-xl" />
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {showMobileMenu && (
          <div className="md:hidden bg-white border-t border-gray-200 px-4 py-3">
            <div className="flex flex-col space-y-3">
              {user ? (
                <>
                  <Link 
                    to="/profile" 
                    className="bg-amber-600 hover:bg-amber-700 text-white px-4 py-3 rounded-lg flex items-center justify-center transition-colors"
                    onClick={() => setShowMobileMenu(false)}
                  >
                    <FaSignInAlt className="mr-2" />
                    <span>Profile</span>
                  </Link>
                  <button 
                    onClick={() => {
                      logout();
                      setShowMobileMenu(false);
                    }}
                    className="bg-white border border-red-600 text-red-600 hover:bg-red-50 px-4 py-3 rounded-lg flex items-center justify-center transition-colors"
                  >
                    <FaSignOutAlt className="mr-2" />
                    <span>Logout</span>
                  </button>
                </>
              ) : (
                <>
                  <Link 
                    to="/login" 
                    className="bg-amber-600 hover:bg-amber-700 text-white px-4 py-3 rounded-lg flex items-center justify-center transition-colors"
                    onClick={() => setShowMobileMenu(false)}
                  >
                    <FaSignInAlt className="mr-2" />
                    <span>Login</span>
                  </Link>
                  <Link 
                    to="/register" 
                    className="bg-white border border-amber-600 text-amber-600 hover:bg-amber-50 px-4 py-3 rounded-lg flex items-center justify-center transition-colors"
                    onClick={() => setShowMobileMenu(false)}
                  >
                    <span>Register</span>
                  </Link>
                </>
              )}
              <div className="flex items-center justify-center space-x-2 pt-2 border-t border-gray-200">
                <button className="flex items-center space-x-1 text-gray-600 hover:text-amber-600 transition-colors min-h-[44px] min-w-[44px] justify-center">
                  <FaGlobe />
                  <span>EN</span>
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="wave-pattern" style={{backgroundImage: "url('data:image/svg+xml,%3Csvg width=\'100\' height=\'20\' viewBox=\'0 0 100 20\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M0 10 C20 0, 40 20, 60 10 S100 0, 100 10\' fill=\'none\' stroke=\'%23d97706\' stroke-width=\'1\'/%3E%3C/svg%3E')", backgroundRepeat: 'repeat-x', backgroundSize: '100px 20px', height: 20}} />
      </header>

      {/* Main Content */}
      <main className={`container mx-auto px-4 py-4 sm:py-8 ${theme === 'moonlight' ? 'relative' : ''}`}>
        {/* Persian Miniature Art Background for Moonlight Mode */}
        {theme === 'moonlight' && (
          <div className="absolute inset-0 pointer-events-none opacity-5">
            <div className="absolute top-10 left-10 w-32 h-32 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full blur-xl"></div>
            <div className="absolute top-1/4 right-20 w-24 h-24 bg-gradient-to-br from-purple-400 to-pink-500 rounded-full blur-xl"></div>
            <div className="absolute bottom-1/4 left-1/4 w-20 h-20 bg-gradient-to-br from-blue-400 to-cyan-500 rounded-full blur-xl"></div>
          </div>
        )}
        {/* Moonlight Mode Announcement */}
        {theme === 'moonlight' && (
          <section className="moonlight-card persian-miniature-border mb-6 sm:mb-8 p-4 sm:p-6">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full mb-4 shadow-lg">
                <FaMoon className="text-white text-2xl" />
              </div>
              <h2 className="text-2xl sm:text-3xl font-bold mb-3">
                <span className="text-amber-400 persian-calligraphy">Moonlight Mode</span>
              </h2>
              <p className="text-lg mb-4">
                Study with our soothing night mode featuring Persian miniature art
              </p>
              <p className="text-sm opacity-80">
                Immerse yourself in the beauty of Persian culture while learning in comfort
              </p>
            </div>
          </section>
        )}

        {/* Hero Section */}
        <section className="bg-gradient-to-r from-amber-50 to-amber-100 rounded-xl p-4 sm:p-6 mb-6 sm:mb-8 shadow-md">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="lg:w-2/3 mb-4 lg:mb-0">
              <h2 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-3 sm:mb-4">
                <span className="block">Ask, Learn, Share</span>
                <span className="text-amber-600 persian-font rtl-text text-lg sm:text-xl">همه چیز درباره فرهنگ و زبان فارسی</span>
              </h2>
              <p className="text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base">Join our community of Persian language learners and culture enthusiasts. Get help with Farsi words, discuss Persian traditions, share recipes, and connect with fellow students.</p>
              <div className="relative max-w-xl">
                <input 
                  type="text" 
                  placeholder="Search questions about Persian..." 
                  className="w-full px-4 py-3 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base" 
                />
                <button className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-amber-600 text-white p-2 rounded-full hover:bg-amber-700 transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center">
                  <FaSearch />
                </button>
              </div>
            </div>
            <div className="lg:w-1/3 flex justify-center">
              <img src="https://img.icons8.com/color/300/persian-gulf.png" alt="Persian Culture" className="w-32 h-32 sm:w-48 sm:h-48 object-contain" />
            </div>
          </div>
        </section>

        {/* Ask & Share - Ta'arof Culture Section */}
        <section className="mb-8 sm:mb-12">
          {/* Section Header */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full mb-4 shadow-lg">
              <FaLaugh className="text-white text-2xl" />
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-3">
              🧵 Ask & Share
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Explore the beautiful world of <span className="font-semibold text-amber-600">Ta'arof</span> culture, 
              share Persian jokes, and learn from common mistakes
            </p>
          </div>

          {/* Feature Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            {/* Ta'arof Culture Card */}
            <div className="group relative overflow-hidden bg-gradient-to-br from-blue-50 to-indigo-100 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-blue-400 to-indigo-500 opacity-10 rounded-full -translate-y-16 translate-x-16 group-hover:scale-110 transition-transform duration-300"></div>
              <div className="relative z-10">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-xl mb-4 shadow-md">
                  <FaHandshake className="text-white text-xl" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">Ta'arof Culture</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Master the art of Persian politeness and social etiquette. Learn when to offer, when to accept, and the subtle dance of Ta'arof.
                </p>
                <div className="flex items-center text-blue-600 font-medium">
                  <span>Explore Culture</span>
                  <FaArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </div>

            {/* Persian Jokes Card */}
            <div className="group relative overflow-hidden bg-gradient-to-br from-green-50 to-emerald-100 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-green-400 to-emerald-500 opacity-10 rounded-full -translate-y-16 translate-x-16 group-hover:scale-110 transition-transform duration-300"></div>
              <div className="relative z-10">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-gradient-to-br from-green-500 to-emerald-600 rounded-xl mb-4 shadow-md">
                  <FaSmile className="text-white text-xl" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">Persian Jokes</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Discover the wit, wordplay, and cultural humor that makes Persian jokes unique and delightful.
                </p>
                <div className="flex items-center text-green-600 font-medium">
                  <span>Share Laughter</span>
                  <FaArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </div>

            {/* Common Mistakes Card */}
            <div className="group relative overflow-hidden bg-gradient-to-br from-red-50 to-rose-100 rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-red-400 to-rose-500 opacity-10 rounded-full -translate-y-16 translate-x-16 group-hover:scale-110 transition-transform duration-300"></div>
              <div className="relative z-10">
                <div className="inline-flex items-center justify-center w-12 h-12 bg-gradient-to-br from-red-500 to-rose-600 rounded-xl mb-4 shadow-md">
                  <FaLightbulb className="text-white text-xl" />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-3">Common Mistakes</h3>
                <p className="text-gray-600 mb-4 leading-relaxed">
                  Learn from others' experiences. Share and discover common pitfalls in learning Persian language and culture.
                </p>
                <div className="flex items-center text-red-600 font-medium">
                  <span>Learn & Grow</span>
                  <FaArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
                </div>
              </div>
            </div>
          </div>

          {/* Interactive Tabs */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
            {/* Tab Navigation */}
            <div className="bg-gradient-to-r from-gray-50 to-gray-100 p-1">
              <div className="flex space-x-1">
                {[
                  { id: 'culture', label: 'Ta\'arof Culture', icon: <FaHandshake />, color: 'blue' },
                  { id: 'jokes', label: 'Persian Jokes', icon: <FaSmile />, color: 'green' },
                  { id: 'mistakes', label: 'Common Mistakes', icon: <FaLightbulb />, color: 'red' }
                ].map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTaarofTab(tab.id)}
                    className={`flex-1 flex items-center justify-center space-x-2 py-4 px-6 rounded-xl font-medium transition-all duration-200 ${
                      activeTaarofTab === tab.id
                        ? `bg-white text-${tab.color}-600 shadow-md`
                        : `text-gray-600 hover:text-${tab.color}-600 hover:bg-white/50`
                    }`}
                  >
                    <span className="text-lg">{tab.icon}</span>
                    <span>{tab.label}</span>
                  </button>
                ))}
              </div>
            </div>

            {/* Tab Content */}
            <div className="p-6">
              {activeTaarofTab === 'culture' && (
                <div className="space-y-6">
                  <div className="text-center mb-8">
                    <h3 className="text-2xl font-bold text-gray-800 mb-3">The Art of Ta'arof</h3>
                    <p className="text-gray-600 max-w-2xl mx-auto">
                      Ta'arof is more than just politeness—it's a complex social dance that reflects the heart of Persian culture.
                    </p>
                  </div>
                  
                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {/* Ta'arof Examples */}
                    <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl p-6">
                      <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                        <FaCoffee className="mr-2 text-blue-600" />
                        Classic Ta'arof Scenarios
                      </h4>
                      <div className="space-y-4">
                        {[
                          { persian: "بفرمایید، شما اول", english: "Please, you first", context: "When entering a door" },
                          { persian: "چشم، حتماً", english: "Of course, definitely", context: "When invited somewhere" },
                          { persian: "نه، شما لطف دارید", english: "No, you're being kind", context: "When complimented" }
                        ].map((item, i) => (
                          <div key={i} className="bg-white rounded-lg p-4 shadow-sm">
                            <div className="flex items-start space-x-3">
                              <div className="flex-shrink-0 w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center">
                                <span className="text-blue-600 font-medium text-sm">{i + 1}</span>
                              </div>
                              <div className="flex-1">
                                <p className="font-medium text-gray-800 mb-1" dir="rtl">{item.persian}</p>
                                <p className="text-gray-600 text-sm mb-1">{item.english}</p>
                                <p className="text-blue-600 text-xs font-medium">{item.context}</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Interactive Quiz */}
                    <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-6">
                      <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                        <FaQuestionCircle className="mr-2 text-amber-600" />
                        Ta'arof Quiz
                      </h4>
                      <div className="space-y-4">
                        <div className="bg-white rounded-lg p-4 shadow-sm">
                          <p className="text-gray-800 mb-3">When someone offers you food, what's the proper Ta'arof response?</p>
                          <div className="space-y-2">
                            {[
                              "Immediately accept",
                              "Say 'no' first, then accept if they insist",
                              "Always refuse politely",
                              "Ask for more details"
                            ].map((option, i) => (
                              <button
                                key={i}
                                className="w-full text-left p-3 rounded-lg border border-gray-200 hover:border-amber-300 hover:bg-amber-50 transition-colors"
                              >
                                {option}
                              </button>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTaarofTab === 'jokes' && (
                <div className="space-y-6">
                  <div className="text-center mb-8">
                    <h3 className="text-2xl font-bold text-gray-800 mb-3">Persian Humor</h3>
                    <p className="text-gray-600 max-w-2xl mx-auto">
                      Discover the wit, wordplay, and cultural humor that makes Persian jokes unique and delightful.
                    </p>
                  </div>

                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {/* Featured Joke */}
                    <div className="bg-gradient-to-br from-green-50 to-emerald-50 rounded-xl p-6">
                      <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                        <FaStar className="mr-2 text-green-600" />
                        Joke of the Day
                      </h4>
                      <div className="bg-white rounded-lg p-6 shadow-sm">
                        <div className="text-center mb-4">
                          <FaRegSmile className="text-4xl text-green-500 mx-auto mb-2" />
                        </div>
                        <p className="text-gray-800 mb-4 leading-relaxed" dir="rtl">
                          یک روز مردی به مغازه رفت و گفت: "آقا، این پیراهن چقدر است؟"
                          فروشنده گفت: "پنجاه هزار تومان"
                          مرد گفت: "خیلی گران است!"
                          فروشنده گفت: "پس چرا پرسیدی؟"
                        </p>
                        <p className="text-gray-600 text-sm mb-4">
                          A man went to a shop and asked: "Sir, how much is this shirt?"
                          The shopkeeper said: "Fifty thousand tomans"
                          The man said: "That's too expensive!"
                          The shopkeeper said: "Then why did you ask?"
                        </p>
                        <div className="flex items-center justify-between">
                          <div className="flex items-center space-x-4">
                            <button className="flex items-center space-x-1 text-gray-500 hover:text-green-600 transition-colors">
                              <FaRegHeart />
                              <span className="text-sm">Like</span>
                            </button>
                            <button className="flex items-center space-x-1 text-gray-500 hover:text-green-600 transition-colors">
                              <FaComment />
                              <span className="text-sm">Share</span>
                            </button>
                          </div>
                          <div className="flex items-center space-x-1 text-yellow-500">
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaStar />
                            <FaRegStar />
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Joke Categories */}
                    <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-6">
                      <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                        <FaUsers className="mr-2 text-purple-600" />
                        Share Your Joke
                      </h4>
                      <div className="space-y-4">
                        <textarea
                          placeholder="Share a Persian joke or funny story..."
                          className="w-full p-4 border border-gray-200 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-purple-500"
                          rows={4}
                        ></textarea>
                        <div className="flex items-center justify-between">
                          <div className="flex space-x-2">
                            {['Wordplay', 'Cultural', 'Family', 'Work'].map((tag) => (
                              <span key={tag} className="px-3 py-1 bg-purple-100 text-purple-700 rounded-full text-sm">
                                {tag}
                              </span>
                            ))}
                          </div>
                          <button className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700 transition-colors">
                            Share Joke
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {activeTaarofTab === 'mistakes' && (
                <div className="space-y-6">
                  <div className="text-center mb-8">
                    <h3 className="text-2xl font-bold text-gray-800 mb-3">Learning from Mistakes</h3>
                    <p className="text-gray-600 max-w-2xl mx-auto">
                      Every mistake is a learning opportunity. Share your experiences and help others avoid common pitfalls.
                    </p>
                  </div>

                  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    {/* Common Mistakes */}
                    <div className="bg-gradient-to-br from-red-50 to-rose-50 rounded-xl p-6">
                      <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                        <FaExclamationTriangle className="mr-2 text-red-600" />
                        Common Mistakes
                      </h4>
                      <div className="space-y-4">
                        {[
                          {
                            mistake: "Using 'khodahafez' too casually",
                            correction: "Use 'bedrood' for close friends, 'khodahafez' for formal situations",
                            category: "Language"
                          },
                          {
                            mistake: "Not understanding Ta'arof refusal",
                            correction: "When someone refuses your offer, insist politely - it's often expected",
                            category: "Culture"
                          },
                          {
                            mistake: "Mispronouncing 'gh' sound",
                            correction: "Practice the guttural 'gh' sound - it's like clearing your throat",
                            category: "Pronunciation"
                          }
                        ].map((item, i) => (
                          <div key={i} className="bg-white rounded-lg p-4 shadow-sm border-l-4 border-red-500">
                            <div className="flex items-start space-x-3">
                              <div className="flex-shrink-0 w-8 h-8 bg-red-100 rounded-full flex items-center justify-center">
                                <span className="text-red-600 font-medium text-sm">{i + 1}</span>
                              </div>
                              <div className="flex-1">
                                <p className="font-medium text-gray-800 mb-1">{item.mistake}</p>
                                <p className="text-gray-600 text-sm mb-2">{item.correction}</p>
                                <span className="inline-block px-2 py-1 bg-red-100 text-red-700 rounded text-xs font-medium">
                                  {item.category}
                                </span>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>

                    {/* Share Your Mistake */}
                    <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-xl p-6">
                      <h4 className="text-lg font-semibold text-gray-800 mb-4 flex items-center">
                        <FaLightbulb className="mr-2 text-orange-600" />
                        Share Your Experience
                      </h4>
                      <div className="space-y-4">
                        <div className="bg-white rounded-lg p-4 shadow-sm">
                          <label className="block text-sm font-medium text-gray-700 mb-2">What mistake did you make?</label>
                          <textarea
                            placeholder="Describe your mistake and what you learned..."
                            className="w-full p-3 border border-gray-200 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-orange-500"
                            rows={3}
                          ></textarea>
                        </div>
                        <div className="bg-white rounded-lg p-4 shadow-sm">
                          <label className="block text-sm font-medium text-gray-700 mb-2">How did you fix it?</label>
                          <textarea
                            placeholder="Share the solution or correction..."
                            className="w-full p-3 border border-gray-200 rounded-lg resize-none focus:outline-none focus:ring-2 focus:ring-orange-500"
                            rows={3}
                          ></textarea>
                        </div>
                        <button className="w-full bg-orange-600 text-white py-3 rounded-lg hover:bg-orange-700 transition-colors font-medium">
                          Share My Learning
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>

        {/* Categories & Tabs */}
        <section className="mb-6 sm:mb-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 mb-4 sm:mb-6">
            {categories.map((cat, i) => {
              const isActive = category === cat.title.toLowerCase().replace(/\s+/g, '-');
              return (
                <Link 
                  key={i} 
                  to={`/forum/category/${cat.title.toLowerCase().replace(/\s+/g, '-')}`}
                  className={`rounded-lg shadow-md p-3 sm:p-4 flex items-center transition-all hover:shadow-lg cursor-pointer ${
                    isActive ? 'bg-amber-50 border-2 border-amber-500' : 'bg-white'
                  }`}
                >
                  <div className={`bg-${cat.color}-100 p-2 sm:p-3 rounded-full mr-3 flex-shrink-0`}>{cat.icon}</div>
                  <div className="min-w-0 flex-1">
                    <h3 className={`font-semibold text-sm sm:text-base ${isActive ? 'text-amber-700' : ''}`}>{cat.title}</h3>
                    <p className="text-xs sm:text-sm text-gray-500">{cat.desc}</p>
                  </div>
                </Link>
              );
            })}
          </div>
          
          {/* Tabs - Mobile Scrollable */}
          <div className="border-b border-gray-200 mb-4 sm:mb-6 overflow-x-auto">
            <nav className="flex space-x-4 sm:space-x-8 min-w-max px-2">
              {tabs.map((tab, i) => (
                <button
                  key={tab.label}
                  className={`py-3 sm:py-4 px-2 sm:px-1 border-b-2 font-medium text-sm whitespace-nowrap min-h-[44px] flex items-center ${activeTab === i ? 'active-tab border-amber-500 text-amber-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`}
                  onClick={() => setActiveTab(i)}
                >
                  {tab.icon} {tab.label}
                </button>
              ))}
            </nav>
          </div>
        </section>

        {/* Questions Section */}
        <section className="mb-6 sm:mb-8">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 sm:mb-6 space-y-3 sm:space-y-0">
            <div className="flex flex-col space-y-2">
              <h2 className="text-xl sm:text-2xl font-bold text-gray-800">
                {category ? `${category.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')} Questions` : 'Popular Questions'}
              </h2>
              {category && (
                <Link 
                  to="/forum" 
                  className="text-amber-600 hover:text-amber-700 text-sm font-medium flex items-center"
                >
                  ← Back to All Categories
                </Link>
              )}
            </div>
            <button 
              className="bg-amber-600 hover:bg-amber-700 text-white px-4 py-3 rounded-full flex items-center justify-center transition-colors w-full sm:w-auto"
              onClick={() => setShowModal(true)}
            >
              <FaPlus className="mr-2" />
              <span>Ask Question</span>
            </button>
          </div>
          
          {/* Question Cards */}
          <div className="space-y-3 sm:space-y-4">
            {displayedQuestions.map((q, i) => (
              <Link key={i} to={`/forum/question/${i + 1}`} className="block">
                <div className={`${theme === 'moonlight' ? 'moonlight-card' : 'bg-white'} rounded-xl shadow-md overflow-hidden topic-card transition duration-300 hover:shadow-lg cursor-pointer`}>
                <div className="p-4 sm:p-6">
                  <div className="flex items-start">
                    <div className="flex-shrink-0 mr-3 sm:mr-4">
                      <img className="h-8 w-8 sm:h-10 sm:w-10 rounded-full" src={q.user.avatar} alt="User avatar" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-2 space-y-1 sm:space-y-0">
                        <p className="text-sm font-medium text-gray-900">{q.user.name}</p>
                        <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-${q.categoryColor}-100 text-${q.categoryColor}-800 w-fit`}>
                          {q.icon} {q.category}
                        </span>
                      </div>
                      <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-2" dir="ltr">{q.title}</h3>
                      <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4" dir="ltr">{q.content}</p>
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-2 sm:space-y-0">
                        <div className="flex space-x-4">
                          <span className="inline-flex items-center text-sm text-gray-500"><FaThumbsUp className="mr-1" /> {q.likes}</span>
                          <span className="inline-flex items-center text-sm text-gray-500"><FaComment className="mr-1" /> {q.answers} answers</span>
                        </div>
                        <span className="text-sm text-gray-500">{q.time}</span>
                      </div>
                    </div>
                  </div>
                </div>
                </div>
              </Link>
            ))}
          </div>
          
          {showLoadMore && (
            <div className="mt-6 flex justify-center">
              <button 
                onClick={handleLoadMore}
                className="bg-white border border-gray-300 text-gray-700 hover:bg-gray-50 px-4 py-3 rounded-full flex items-center transition-colors min-h-[44px]"
              >
                <span>Load More Questions</span>
                <FaChevronDown className="ml-2" />
              </button>
            </div>
          )}
        </section>

        {/* Persian Learning Resources */}
        <section className="mb-6 sm:mb-8 bg-white rounded-xl p-6 shadow-md">
          <h2 className="text-xl sm:text-2xl font-bold text-gray-800 mb-4 sm:mb-6">Persian Learning Resources</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {resources.map((r, i) => (
              <div key={i} className={`${theme === 'moonlight' ? 'moonlight-card' : 'bg-white'} rounded-xl shadow-md overflow-hidden hover:shadow-lg transition duration-300`}>
                <div className="p-4 sm:p-6">
                  <div className="flex items-center mb-3 sm:mb-4">
                    <div className={`bg-${r.color}-100 p-2 sm:p-3 rounded-full mr-3 sm:mr-4 flex-shrink-0`}>{r.icon}</div>
                    <h3 className="text-base sm:text-lg font-semibold">{r.title}</h3>
                  </div>
                  <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">{r.desc}</p>
                  <a 
                    href={r.link} 
                    className={`text-${r.color}-600 hover:text-${r.color}-700 font-medium flex items-center transition-colors min-h-[44px]`}
                  >
                    {r.linkText}
                    <FaArrowRight className="ml-2" />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-gray-800 text-white pt-8 sm:pt-12 pb-6">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8">
            <div>
              <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4 flex items-center">
                <FaMosque className="text-amber-400 mr-2" />
                <span className="persian-font">دانشجویان فارسی</span>
              </h3>
              <p className="text-sm sm:text-base text-gray-400">Your community for learning Persian language and culture. Ask questions, share knowledge, and connect with fellow enthusiasts.</p>
            </div>
            <div>
              <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li><Link to="/" className="text-sm sm:text-base text-gray-400 hover:text-amber-400 transition-colors">Home</Link></li>
                <li><Link to="/forum" className="text-sm sm:text-base text-gray-400 hover:text-amber-400 transition-colors">Popular Questions</Link></li>
                <li><Link to="/forum" className="text-sm sm:text-base text-gray-400 hover:text-amber-400 transition-colors">Categories</Link></li>
                <li><Link to="/learning-guide" className="text-sm sm:text-base text-gray-400 hover:text-amber-400 transition-colors">Resources</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Categories</h3>
              <ul className="space-y-2">
                <li><Link to="/vocabulary" className="text-sm sm:text-base text-gray-400 hover:text-amber-400 transition-colors">Farsi Language</Link></li>
                <li><Link to="/cultural" className="text-sm sm:text-base text-gray-400 hover:text-amber-400 transition-colors">Persian Culture</Link></li>
                <li><Link to="/food-guide" className="text-sm sm:text-base text-gray-400 hover:text-amber-400 transition-colors">Persian Cuisine</Link></li>
                <li><Link to="/hafez" className="text-sm sm:text-base text-gray-400 hover:text-amber-400 transition-colors">Literature & Poetry</Link></li>
              </ul>
            </div>
            <div>
              <h3 className="text-base sm:text-lg font-semibold mb-3 sm:mb-4">Connect With Us</h3>
              <div className="flex space-x-3 sm:space-x-4 mb-3 sm:mb-4">
                <a href="https://t.me/vajakapp" target="_blank" rel="noopener noreferrer" className="bg-gray-700 hover:bg-amber-600 w-10 h-10 rounded-full flex items-center justify-center transition-colors"><FaTelegram /></a>
                <a href="https://twitter.com/vajakapp" target="_blank" rel="noopener noreferrer" className="bg-gray-700 hover:bg-blue-600 w-10 h-10 rounded-full flex items-center justify-center transition-colors"><FaTwitter /></a>
                <a href="https://instagram.com/vajakapp" target="_blank" rel="noopener noreferrer" className="bg-gray-700 hover:bg-pink-600 w-10 h-10 rounded-full flex items-center justify-center transition-colors"><FaInstagram /></a>
                <a href="https://youtube.com/vajakapp" target="_blank" rel="noopener noreferrer" className="bg-gray-700 hover:bg-red-600 w-10 h-10 rounded-full flex items-center justify-center transition-colors"><FaYoutube /></a>
              </div>
              <p className="text-sm sm:text-base text-gray-400 mb-2">Subscribe to our newsletter for updates</p>
              <div className="flex">
                <input 
                  type="email" 
                  placeholder="Your email" 
                  className="px-3 py-2 bg-gray-700 text-white rounded-l focus:outline-none w-full text-sm sm:text-base" 
                />
                <button className="bg-amber-600 hover:bg-amber-700 px-3 py-2 rounded-r transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center">
                  <FaPaperPlane />
                </button>
              </div>
            </div>
          </div>
          <div className="border-t border-gray-700 pt-4 sm:pt-6 flex flex-col sm:flex-row justify-between items-center space-y-3 sm:space-y-0">
            <p className="text-sm sm:text-base text-gray-400">© 2024 پیروز Pirooz. All rights reserved.</p>
            <div className="flex space-x-4 sm:space-x-6">
              <Link to="/terms" className="text-sm sm:text-base text-gray-400 hover:text-amber-400 transition-colors">Terms</Link>
              <Link to="/privacy" className="text-sm sm:text-base text-gray-400 hover:text-amber-400 transition-colors">Privacy</Link>
              <Link to="/faq" className="text-sm sm:text-base text-gray-400 hover:text-amber-400 transition-colors">FAQ</Link>
              <Link to="/contact" className="text-sm sm:text-base text-gray-400 hover:text-amber-400 transition-colors">Contact</Link>
            </div>
          </div>
        </div>
      </footer>

      {/* Floating Action Button */}
      <div className="fixed bottom-4 sm:bottom-6 right-4 sm:right-6 z-40">
        <button 
          onClick={() => setShowModal(true)} 
          className="bg-amber-600 hover:bg-amber-700 text-white w-14 h-14 rounded-full shadow-lg flex items-center justify-center transition-colors"
        >
          <FaQuestionCircle className="text-xl sm:text-2xl" />
        </button>
      </div>

      {/* Ask Question Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
            <div className="p-4 sm:p-6">
              <div className="flex justify-between items-center mb-4">
                <h3 className="text-lg sm:text-xl font-bold text-gray-800">Ask Your Question</h3>
                <button 
                  onClick={() => setShowModal(false)} 
                  className="text-gray-500 hover:text-gray-700 transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center"
                >
                  <FaTimes />
                </button>
              </div>
              <form>
                <div className="mb-4">
                  <label htmlFor="question-title" className="block text-sm font-medium text-gray-700 mb-1">Question Title</label>
                  <input 
                    type="text" 
                    id="question-title" 
                    className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base" 
                    placeholder="Be specific about your Persian-related question" 
                  />
                </div>
                <div className="mb-4">
                  <label htmlFor="question-category" className="block text-sm font-medium text-gray-700 mb-1">Category</label>
                  <select 
                    id="question-category" 
                    className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base"
                  >
                    <option value="">Select a category</option>
                    <option value="language">Farsi Language</option>
                    <option value="culture">Persian Culture</option>
                    <option value="cuisine">Persian Cuisine</option>
                    <option value="literature">Literature</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="mb-4">
                  <label htmlFor="question-details" className="block text-sm font-medium text-gray-700 mb-1">Details</label>
                  <textarea 
                    id="question-details" 
                    rows={5} 
                    className="w-full px-3 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-amber-500 text-sm sm:text-base" 
                    placeholder="Provide more details about your question..."
                  ></textarea>
                </div>
                <div className="flex flex-col sm:flex-row justify-end space-y-3 sm:space-y-0 sm:space-x-3">
                  <button 
                    type="button" 
                    onClick={() => setShowModal(false)} 
                    className="px-4 py-3 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors text-sm sm:text-base"
                  >
                    Cancel
                  </button>
                  <button 
                    type="submit" 
                    className="px-4 py-3 bg-amber-600 text-white rounded-md hover:bg-amber-700 focus:outline-none focus:ring-2 focus:ring-amber-500 transition-colors text-sm sm:text-base"
                  >
                    Post Question
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Forum; 